package myConst

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import ru.malygin.dto.MainScheduleItemDto
import ru.malygin.myConst.ScheduleChange

@Serializable
sealed class StorageAdaptersSealed {

    @Serializable
    @SerialName("main_list")
    data class MainList(
        val data: List<MainScheduleItemDto>?,
    ): StorageAdaptersSealed()

    @Serializable
    @SerialName("schedule_list")
    data class ScheduleList(
        val data: List<ScheduleChange>?,
    ): StorageAdaptersSealed()
}
fun StorageAdaptersSealed.fromJsonToString(): String{
    return try {
        Json.encodeToString<StorageAdaptersSealed>(
            value = this
        )
    } catch (_: Exception){"{}"}
}

fun String.fromStringToStorage(): StorageAdaptersSealed?{
    return try {
        Json.decodeFromString<StorageAdaptersSealed>(
            this
        )
    }catch (_: Exception){null}
}

sealed class TestSealed{

    data object Loading: TestSealed()

    data class Error(
        val message: String = "error"
    ) : TestSealed()

    data class Success(
        val data: String = "success"
    ): TestSealed()
}